export const LIST_TRANSACTIONS = /* GraphQL */ `
  query listTransactions(
    $limit: Int
    $nextToken: String
    $brandName: String
    $filter: TransactionFilter
  ) {
    listTransactions(
      limit: $limit
      nextToken: $nextToken
      brandName: $brandName
      filter: $filter
    ) {
      count
      nextToken
      items {
        id
        buyerId
        brandName
        createdAt
        isCancelRequestSent
        isRefundRequestSent
        orderId
        orderStatus {
          status
          timestamp
        }
        paymentStatus
        productId
        receiptUrl
        sellerId
        state
        totalPrice
        productPrice
        source
        shopify {
          orderId
          orderDate
          fulfillmentStatus
        }
      }
      }
  }
`